import _ from "lodash";
import moment from "moment";

import {
  Badge,
  Row,
  Col,
  Button,
  Card,
  Collapse,
  Divider,
  Icon,
  List,
  Spin,
  Tag,
  Tooltip,
  message,
  Tabs,
  Modal,
  Typography,
} from "antd";

import React, { Fragment, PureComponent } from "react";
import { Map } from "immutable";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import { checkFeature, hasPermission, filterByEquivalencies } from "../../../utils";
import { Permissions } from "../../../roles.config";

import { AttachmentModal } from "./AttachmentModal";
import * as actions from "../../../actions";
import { LiveDate } from "../../LiveDate";
import { ActionText, DefinedTerm, PortalChild } from "../../elements";

const { Text } = Typography;
const { confirm } = Modal;
const STATUS_NA = "STATUS_NA";

const NON_REVALIDATION_ACCRED_TYPES = ["npc", "ipc"];
const EXPIRY_NOT_PROVIDED = ["wawwc", "nesa"];

const ahpraPayloadTable = (payload, visible, handleCancel) => {
  const data = [];
  const payloadJS = payload.toJS();

  const { TabPane } = Tabs;

  Object.keys(payloadJS).forEach((key, index) =>
    data.push({
      category: key,
      key: index,
      details: Array.isArray(payloadJS[key])
        ? payloadJS[key].join(", ")
        : payloadJS[key],
    }),
  );

  const splitCamelCaseWithAbbreviations = (s) => {
    const terms = s.split(/([A-Z][a-z]+)/).filter((e) => e); // filter removes empty strings
    return terms.map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" ");
  };

  return (
    <Modal
      destroyOnClose={true}
      style={{ minWidth: 750 }}
      visible={visible}
      title="AHPRA Details"
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Cancel
        </Button>,
      ]}
    >
      <Tabs defaultActiveKey="0">
        {payloadJS.sections &&
          payloadJS.sections.map((section, idx) => (
            <TabPane tab={section.label} key={idx}>
              {section &&
                Object.keys(section)
                  .filter((key) => key !== "label")
                  .map((key, idx) => (
                    <div
                      style={{
                        width: "80%",
                        margin: "auto",
                        marginBottom: "1rem",
                      }}
                    >
                      {idx > 0 && <Divider />}
                      <h4>{splitCamelCaseWithAbbreviations(key)}</h4>
                      <p style={{ display: "inline" }}>{section[key]}</p>
                    </div>
                  ))}
            </TabPane>
          ))}
      </Tabs>
    </Modal>
  );
};

const vevoPayloadTable = (payload, visible, handleCancel) => {
  const data = [];
  const payloadJS = payload.toJS();

  const { TabPane } = Tabs;

  Object.keys(payloadJS).forEach((key, index) =>
    data.push({
      category: key,
      key: index,
      details: Array.isArray(payloadJS[key])
        ? payloadJS[key].join(", ")
        : payloadJS[key],
    }),
  );

  const splitCamelCaseWithAbbreviations = (s) => {
    const terms = s.split(/([A-Z][a-z]+)/).filter((e) => e); // filter removes empty strings
    return terms.map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" ");
  };

  return (
    <Modal
      destroyOnClose={true}
      style={{ minWidth: 750 }}
      visible={visible}
      title="VEVO Details"
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Close
        </Button>,
      ]}
    >
      <Tabs defaultActiveKey="0">
        {payloadJS.sections &&
          payloadJS.sections.map((section, idx) => (
            <TabPane tab={section.label} key={idx}>
              {section &&
                Object.keys(section)
                  .filter((key) => key !== "label")
                  .map((key, idx) => (
                    <div
                      style={{
                        width: "80%",
                        margin: "auto",
                        marginBottom: "1rem",
                      }}
                    >
                      {idx > 0 && <Divider />}
                      <h4>{splitCamelCaseWithAbbreviations(key)}</h4>
                      <p style={{ display: "inline" }}>{parse(section[key])}</p>
                    </div>
                  ))}
            </TabPane>
          ))}
      </Tabs>
    </Modal>
  );
};

class AccreditationFieldStatus extends PureComponent {
  render() {
    if (_.isNil(this.props.okay))
      return <Spin size="small" style={{ paddingRight: "4px" }} />;

    const { color, icon, msg } = {
      true: {
        color: "green",
        icon: "check-circle",
        msg: this.props.goodMsg,
      },
      false: {
        color: "red",
        icon: "exclamation-circle",
        msg: this.props.badMsg,
      },
      warn: {
        color: "orange",
        icon: "info-circle",
        msg: this.props.warnMsg,
      },
      notFound: {
        color: "red",
        icon: "exclamation-circle",
        msg: "Card Not Found",
      },
      STATUS_NA: {
        color: "grey",
        icon: "exclamation-circle",
        msg: this.props.naMsg || this.props.badMsg,
      },
      with_conditions: {
        color: "orange",
        icon: "check-circle",
        msg: this.props.badMsg,
      },
      without_conditions: {
        color: "green",
        icon: "check-circle",
        msg: this.props.goodMsg,
      },
      not_current: {
        color: "red",
        icon: "exclamation-circle",
        msg: this.props.badMsg,
      },
      eligible: {
        color: "green",
        icon: "check-circle",
        msg: this.props.goodMsg,
      },
      not_eligible: {
        color: "red",
        icon: "exclamation-circle",
        msg: this.props.badMsg,
      },
      must_not_engage: {
        color: "red",
        icon: "exclamation-circle",
        msg: this.props.badMsg,
      },
      may_engage: {
        color: "green",
        icon: "check-circle",
        msg: this.props.goodMsg,
      },
    }[this.props.okay];

    return (
      <Tooltip title={msg}>
        <Icon type={icon} style={{ color, paddingRight: "4px" }} />
      </Tooltip>
    );
  }
}

const ACCREDITATION_CLAIM_DETAIL_ROWS = [
  // VicWWC new card
  (claim) => {
    const show = claim.getIn(["meta", "vicwwc", "isNewCard"], false);
    if (!show) {
      return null;
    }
    return (
      <div key="vicwwc-is-new-card">
        <AccreditationFieldStatus
          okay={"warn"}
          warnMsg="Contact person for details of their new card"
        />
        New card details available
      </div>
    );
  },

  (claim) => {
    const statusFlags = claim.getIn(["statusFlags"], []).toJS();
    const show = statusFlags && statusFlags.includes("is_application");
    if (!show) {
      return null;
    }
    return (
      <div key="is-application">
        <AccreditationFieldStatus
          okay={"warn"}
          warnMsg={
            "Confirm suitability of engaging this person while the application is being processed."
          }
        />
        Application is in progress
      </div>
    );
  },

  // Awaiting Decision - shown when no decision has been recorded
  (claim, props) => {
    // Get claimMeta from props (where the decision field is stored)
    const claimMeta =
      props && props.claimMeta
        ? Map.isMap(props.claimMeta)
          ? props.claimMeta.toJS()
          : props.claimMeta
        : {};
    const decision = claimMeta.decision;
    //const settings = props && props.settings && props.settings.toJSON()
    const { settings } = props;
    if (!settings) return null;
    const settingsJSON = settings.toJSON() || {}

    const actionTrackerEnabled = settingsJSON.providers && settingsJSON.providers.actionTracker && settingsJSON.providers.actionTracker.enabled;

    // If from ActionsPage, check actionTaken prop
    if (!actionTrackerEnabled) return null;
    if (props && "actionTaken" in props) {
      const actionTaken = props.actionTaken;
      if (actionTaken && actionTaken !== "") {
        return null;
      }
      // Show awaiting decision for ActionsPage items without action taken
      return (
        <div key="action-pending">
          <AccreditationFieldStatus
            okay={"warn"}
            warnMsg="This accreditation requires a decision to be made"
          />
          Awaiting Decision
        </div>
      );
    }

    // For ConstituentPage: only show if decision field exists (indicating it's in the action tracker)
    // and the decision is empty or pending-type
    if (decision !== undefined && decision !== null) {
      const decisionLower =
        typeof decision === "string" ? decision.toLowerCase() : "";
      const isAwaitingDecision =
        decision === "" ||
        decisionLower === "action pending" ||
        decisionLower === "awaiting decision";

      if (isAwaitingDecision) {
        return (
          <div key="action-pending">
            <AccreditationFieldStatus
              okay={"warn"}
              warnMsg="This accreditation requires a decision to be made"
            />
            Awaiting Decision
          </div>
        );
      }
    }

    return null;
  },
];

function checkGeneric(scanTypes, accred) {
  if (!accred) {
    return null;
  }
  const type = accred.get("type");
  const scanTypesJs = scanTypes && scanTypes.toObject ? scanTypes.toJS() : [];
  const itemFound = scanTypesJs.find((item) => item.typeCode === type);
  return itemFound && (!itemFound.scanner || itemFound.scanner === "");
}

function getAccredMaxAttachments(scanTypes, accred) {
  if (!accred) {
    return null;
  }
  const type = accred.get("type");
  const scanTypesJs = scanTypes && scanTypes.toObject ? scanTypes.toJS() : [];
  const itemFound = scanTypesJs.find((item) => item.typeCode === type);
  const maxAttachments = (itemFound && itemFound.maxAttachments) || "";
  return maxAttachments && maxAttachments !== "" ? maxAttachments : 0;
}

const statusRules = {
  conditional: (obj) => ({
    fieldStatus: "with_conditions",
    negativeMsg: "Accreditation is conditional or limited",
    positiveMsg: "",
  }),
  engage: (obj) => {
    if (obj.mayEngage) {
      return {
        fieldStatus: "may_engage",
        negativeMsg: "",
        positiveMsg: `Accreditation is ${obj.response || "current"}`,
      };
    }
    return {
      fieldStatus: "must_not_engage",
      negativeMsg: `Accreditation is ${obj.response || "not current"}`,
      positiveMsg: "",
    };
  },
  response: {
    "not current": (obj) => ({
      fieldStatus: "not_current",
      negativeMsg: "Accreditation is not current",
      positiveMsg: "Response is not current",
    }),
    "not found": (obj) => ({
      fieldStatus: "false",
      negativeMsg: "Accreditation is not found",
      positiveMsg: "Response is not current",
    }),
    "not eligible to work": (obj) => ({
      fieldStatus: "not_eligible",
      negativeMsg: "Not eligible to work",
      positiveMsg: "",
    }),
    incomplete: (obj) => ({
      fieldStatus: "not_eligible",
      negativeMsg: "Not eligible to work",
      positiveMsg: "",
    }),
    "under assessment": (obj) => ({
      fieldStatus: "not_eligible",
      negativeMsg: "Not eligible to work",
      positiveMsg: "",
    }),
    "eligible to work": (obj) => ({
      fieldStatus: "not_current",
      negativeMsg: "Accreditation is not current",
      positiveMsg: "Response is not current",
    }),
    "no work rights": (obj) => ({
      fieldStatus: "not_current",
      negativeMsg: obj.supplement,
      positiveMsg: obj.supplement,
    }),
    "limited work rights": (obj) => ({
      fieldStatus: "with_conditions",
      negativeMsg: obj.supplement,
      positiveMsg: obj.supplement,
    }),
    "unlimited work rights": (obj) => ({
      fieldStatus: "true",
      negativeMsg: obj.supplement,
      positiveMsg: obj.supplement,
    }),
  },
};

const getStatusFromRegistryResponse = (registryResponse) => {
  const registryResponseObj = registryResponse && registryResponse.toJS();
  const { isConditional, response, mayEngage } = registryResponseObj || {};
  const result = {
    fieldStatus: "true",
    negativeMsg: "",
    positiveMsg: "",
  };

  // Check conditions
  if (isConditional && statusRules.conditional) {
    Object.assign(result, statusRules.conditional(isConditional));
  }

  // Check response
  if (typeof response === "string") {
    const normalizedResponse = response.trim().toLowerCase();
    if (statusRules.response[normalizedResponse]) {
      Object.assign(
        result,
        statusRules.response[normalizedResponse](registryResponseObj),
      );
    }
  }

  if (typeof mayEngage === "boolean") {
    Object.assign(result, statusRules.engage(registryResponseObj));
  }

  return result;
};

@connect((state, ownProps) => ({
  isGeneric: checkGeneric(
    state.doc.getIn(["http", "scanTypes", "data"]),
    ownProps.accreditation,
  ),
  accreditationMaxAttachments: getAccredMaxAttachments(
    state.doc.getIn(["http", "scanTypes", "data"]),
    ownProps.accreditation,
  ),
}))
class AccreditationListClaimBody extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      moreDetailsIsVisible: false,
      attchmentModalVisible: false,
    };
  }

  renderExpiry(accType, value, type = "expiry") {
    if (!value && accType && EXPIRY_NOT_PROVIDED.includes(accType))
      return (
        <DefinedTerm definition="This card expiry is not managed">
          Not Provided
        </DefinedTerm>
      );
    if (!value)
      return (
        <DefinedTerm definition="This card type does not expire">
          Unknown
        </DefinedTerm>
      );
    const m = moment(value);
    const expiryTerm = moment().diff(m) >= 0 ? "Expired" : "Expires";
    return (
      <Fragment>
        {type === "attainment" ? "Attained" : expiryTerm}{" "}
        <DefinedTerm definition={m.format("Do MMM YYYY")}>
          {m.fromNow()}
        </DefinedTerm>
      </Fragment>
    );
  }

  renderNswwwcOrgRef(orgRef) {
    if (!orgRef) return null;
    const orgName = orgRef.split(" [")[0];
    const orgRefId = orgRef.split("[")[1].split("]")[0];
    return <Tooltip title={orgName}>{orgRefId}</Tooltip>;
  }

  handleRevalidateClick = async () => {
    this.setState({ rescanSubmitting: true });
    const resp = await this.props.postAccreditationRescan(
      this.props.accreditation.get("id"),
    );
    this.setState({ rescanSubmitting: false });
    if (resp.success)
      message.success(
        "Submitted revalidation. Your accreditation will be revalidated soon.",
      );
    if (resp.failed)
      message.success(
        "There was a problem submitting your revalidation request.",
      );
  };

  handleDeleteAttachment = (id, index) => {
    const that = this;
    const constituentId = this.props.constituent.get("id");
    confirm({
      title: "Do you want to delete the attachment request?",
      content: (
        <>
          This will result in deletion of <b>Attachment{index + 1}</b>
        </>
      ),
      async onOk() {
        await that.props.deleteAttachment(id);
        if (constituentId) await that.props.getConstituent(constituentId);
      },
      onCancel() {},
    });
  };

  generalTypesPayloadTable = (visible, handleCancel, type) => {
    const metaKey = type === "usi" ? "usi" : type === "agedcarebanningorder" ? "agedcarebanningorder" : "genacc";
    const gen = this.props.accreditation.getIn(["meta", metaKey], null);
    const accredInfo = gen.toJS();

    const categories = {
      insurance: ["chattins", "profins", "profinspi", "profinspl"],
      academic: ["usi", "acadqual"],
    };

    let payloadType = type;
    for (const category in categories) {
      if (categories[category].includes(type)) {
        payloadType = category;
        break;
      }
    }

    const payloadConfig = {
      dldriverlicense: {
        includedKeys: ["licenseClass", "state", "restrictions"],
        title: "Drivers Licence Details",
      },
      insurance: {
        includedKeys: [
          "insuranceType",
          "insuredAmount",
          "issuedBy",
          "state",
          "conditions",
        ],
        title: "Insurance Details",
      },
      academic: {
        includedKeys: [
          "courseLevel",
          "issuedBy",
          "courseCode",
          "courseCompleted",
        ],
        title: "Qualification Details",
      },
      agedcarebanningorder: {
        includedKeys: [
          "firstName",
          "middleName",
          "surname",
          "status",
          "description",
          "banStartDate",
          "banEndDate",
          "alsoKnownAs",
        ],
        title: "Aged Care Banning Order Details",
      },
    };

    const { includedKeys, title } = payloadConfig[payloadType];

    const { TabPane } = Tabs;

    const formatColumnName = (s) =>
      s.includes("_")
        ? s.split("_").map((t) => t.charAt(0).toUpperCase() + t.slice(1)).join(" ")
        : s
            .split(/([A-Z][a-z]+)/)
            .filter((e) => e)
            .map((t) => t.charAt(0).toUpperCase() + t.slice(1))
            .join(" ");

    return (
      <Modal
        destroyOnClose={true}
        style={{ minWidth: 750 }}
        visible={visible}
        title={title}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Close
          </Button>,
        ]}
      >
        <Tabs defaultActiveKey="details">
          <TabPane tab="Details" key="details">
            {includedKeys
              .filter((key) => key in accredInfo)
              .map((key, idx) => (
                <div
                  key={idx}
                  style={{
                    width: "100%",
                    margin: "auto",
                    marginBottom: "1rem",
                  }}
                >
                  {idx > 0 && <Divider />}
                  <h4>{formatColumnName(key)}</h4>
                  <p>
                    {typeof accredInfo[key] === "boolean"
                      ? accredInfo[key]
                        ? "Yes"
                        : "No"
                      : Array.isArray(accredInfo[key])
                        ? accredInfo[key].length > 0
                          ? accredInfo[key].join(", ")
                          : "N/A"
                        : (key === "banEndDate" && !accredInfo[key])
                          ? "Indefinite"
                          : (accredInfo[key] === null || accredInfo[key] === undefined || accredInfo[key] === "")
                            ? "N/A"
                            : accredInfo[key]}
                  </p>
                </div>
              ))}
          </TabPane>
        </Tabs>
      </Modal>
    );
  };

  renderAccreditationDetails(
    ahpra,
    accredType,
    messages,
    shouldMaskDlDriverLicenceId,
  ) {
    const { accreditation } = this.props;
    const { moreDetailsIsVisible } = this.state;
    const identifier = shouldMaskDlDriverLicenceId
      ? "** MASKED **"
      : accreditation.get("identifier");
    const handleShowMore = () => {
      const metaKey = accredType === "usi" ? "usi" : accredType === "agedcarebanningorder" ? "agedcarebanningorder" : "genacc";
      const metaData = this.props.accreditation.getIn(["meta", metaKey], null);
this.setState({ moreDetailsIsVisible: true });
    };
    const handleHideMore = () => this.setState({ moreDetailsIsVisible: false });
    const additionalInfoTypes = [
      "chattins",
      "profins",
      "profinspi",
      "profinspl",
      "dldriverlicense",
      "acadqual",
      "usi",
      "agedcarebanningorder",
    ];
    if (ahpra) {
      return (
        <>
          {identifier}
          <Text
            style={{ marginLeft: 10, color: "#1890ff", cursor: "pointer" }}
            onClick={handleShowMore}
          >
            More..
          </Text>
          {ahpraPayloadTable(ahpra, moreDetailsIsVisible, handleHideMore)}
        </>
      );
    }
    if (additionalInfoTypes.includes(accredType)) {
      return (
        <>
          {identifier}
          <Text
            style={{ marginLeft: 10, color: "#1890ff", cursor: "pointer" }}
            onClick={handleShowMore}
          >
            More..
          </Text>
          {this.generalTypesPayloadTable(
            moreDetailsIsVisible,
            handleHideMore,
            accredType,
          )}
        </>
      );
    }

    const tooltipTitle = messages.length > 0 ? messages.join(",") : null;
    return <Tooltip title={tooltipTitle}>{identifier}</Tooltip>;
  }

  render() {
    const expiry = this.props.accreditation.get("expiry");
    const { isGeneric, viewOnly } = this.props;
    const attachments = this.props.attachments
      ? this.props.attachments.toJS()
      : null;
    const activeAttachments = attachments.filter((a) => a.active === true);
    const activeGoodMsg = (
      <span>
        Accreditation is valid (checked{" "}
        <LiveDate
          date={this.props.accreditation.getIn([
            "latestVerificationEvent",
            "eventTs",
          ])}
        />
        )
      </span>
    );
    const activeBadMsg = (
      <span>
        Accreditation may have been revoked (checked{" "}
        <LiveDate
          date={this.props.accreditation.getIn([
            "latestVerificationEvent",
            "eventTs",
          ])}
        />
        )
      </span>
    );
    const accredType = this.props.accreditation.get("type");

    // Check if user has permission to view NPC attachments
    const { userRole } = this.props;
    const canViewNpcAttachments = userRole
      ? hasPermission(userRole, Permissions.PC_TRACKING_BASE)
      : false;
    const isNpcAccreditation = accredType === "npc";
    const shouldRestrictAttachments =
      isNpcAccreditation && !canViewNpcAttachments;

    const accredMeta = this.props.accreditation.get("meta").toJS();
    const claimMeta = this.props.claimMeta
      ? Map.isMap(this.props.claimMeta)
        ? this.props.claimMeta.toJS()
        : this.props.claimMeta
      : {};
    const decision = claimMeta.decision;
    const nswNotFound = this.props.accreditation.getIn([
      "meta",
      "nswwwc",
      "reviewRequired",
    ]);
    const registryResponse = this.props.accreditation.getIn(
      ["registryResponse"],
      null,
    );
    const type = this.props.accreditation.getIn(
      ["registryResponse", "type"],
      null,
    );
    const response = this.props.accreditation.getIn(
      ["registryResponse", "response"],
      null,
    );
    const status = this.props.accreditation.getIn(
      ["registryResponse", "status"],
      null,
    );
    const profession = this.props.accreditation.getIn(
      ["registryResponse", "profession"],
      null,
    );
    const supplement = this.props.accreditation.getIn(
      ["registryResponse", "supplement"],
      null,
    );
    const isConditional = this.props.accreditation.getIn(
      ["registryResponse", "isConditional"],
      null,
    );
    const attained = this.props.accreditation.getIn(["attained"], null);
    const messages = this.props.accreditation.getIn(
      ["meta", "status", "messages"],
      null,
    )
      ? this.props.accreditation
          .getIn(["meta", "status", "messages"], null)
          .toJS()
      : [];
    const ahpra = this.props.accreditation.getIn(["meta", "ahpra"], null);
    const vevo = this.props.accreditation.getIn(["meta", "vevo"], null);
    const npc = this.props.accreditation.getIn(["meta", "npc"], null);
    const maskDecisionNpc = this.props.maskDecisionNpc || false;
    const maskDldriverlicenceId = this.props.maskDldriverlicenceId || false;
    const renderObj = (obj) =>
      obj && typeof obj !== "string" ? `${obj.toJS().join(", ")}` : obj;
    const renderType = renderObj(type);
    let renderResponse = renderObj(response);
    if (npc && maskDecisionNpc) renderResponse = "** MASKED **";
    const shouldMaskDlDriverLicenceId =
      accredType === "dldriverlicense" && maskDldriverlicenceId;
    const attachmentButton = !viewOnly &&
      !shouldRestrictAttachments &&
      this.props.accreditationMaxAttachments > 0 &&
      activeAttachments.length < this.props.accreditationMaxAttachments && (
        <div style={{ paddingTop: "1em" }}>
          <Button
            icon="paper-clip"
            size="small"
            type="secondary"
            onClick={() => this.setState({ attchmentModalVisible: true })}
          >
            Attachment
          </Button>
        </div>
      );
    const accred =
      this.props.accreditations &&
      this.props.accreditations.find(
        (accred) => accred.id === this.props.accreditation.get("id"),
      );

    let nswwwcOrgRef;
    if (accredType === "nswwwc" && accred.claimMeta) {
      nswwwcOrgRef = accred.claimMeta.orgRef;
    }

    let linked = null;
    if (
      accred &&
      accred.statusDetail &&
      accred.statusDetail.linkage &&
      accred.statusDetail.linkage.linked
    ) {
      linked = (
        <Tooltip
          title={`This accreditation has been linked to your ${accred.statusDetail.linkage.typeName} account.`}
        >
          <Icon type="link" style={{ color: "green" }} />
        </Tooltip>
      );
    }

    const { fieldStatus, positiveMsg, negativeMsg } =
      getStatusFromRegistryResponse(registryResponse);
    const issuedBy =
      (accredMeta[accredType] && accredMeta[accredType].issuedBy) ||
      (accredMeta.genacc && accredMeta.genacc.issuedBy) ||
      null;
    return (
      <>
        <div>
          <Row>
            <Col span={16}>
              <div>
                <AccreditationFieldStatus
                  okay={nswNotFound ? "notFound" : this.props.nameMatch}
                  goodMsg="Person name matches"
                  badMsg="Person name doesn't match"
                />
                {this.props.accreditation.get("name")}
              </div>
              {response ? (
                <div>
                  <AccreditationFieldStatus
                    okay={fieldStatus}
                    goodMsg={positiveMsg}
                    badMsg={negativeMsg}
                  />
                  {vevo ? (
                    <>
                      {`${response} `}
                      <Text
                        style={{
                          marginLeft: 10,
                          color: "#1890ff",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({ moreDetailsIsVisible: true })
                        }
                      >
                        More..
                      </Text>
                      {vevoPayloadTable(
                        vevo,
                        this.state.moreDetailsIsVisible,
                        () => this.setState({ moreDetailsIsVisible: false }),
                      )}
                    </>
                  ) : (
                    renderResponse
                  )}
                </div>
              ) : (
                renderType
              )}
              {ahpra ? (
                <div>
                  <AccreditationFieldStatus
                    okay={
                      isConditional ? "with_conditions" : "without_conditions"
                    }
                    goodMsg={"Without Conditions"}
                    badMsg={isConditional && supplement}
                  />
                  {profession}
                </div>
              ) : null}
              <div>
                {decision && this.props.actionTaken && (
                  <div>
                    <AccreditationFieldStatus okay={true} />
                    {decision}
                  </div>
                )}
              </div>
              <div>
                <AccreditationFieldStatus
                  okay={
                    nswNotFound
                      ? "notFound"
                      : this.props.accreditation.getIn(
                          ["meta", "status", "current"],
                          false,
                        )
                  }
                  goodMsg={activeGoodMsg}
                  badMsg={activeBadMsg}
                />
                {this.renderAccreditationDetails(
                  ahpra,
                  accredType,
                  messages,
                  shouldMaskDlDriverLicenceId,
                )}
                {linked}
              </div>
              {issuedBy && (
                <div>
                  <AccreditationFieldStatus okay={true} />
                  {issuedBy}
                </div>
              )}
              <div>
                {attained ? (
                  <div>
                    <AccreditationFieldStatus
                      okay={!!attained}
                      goodMsg="Accreditation attainment date"
                      badMsg="Accreditation does not have an attainment date"
                    />
                    {this.renderExpiry(accredType, attained, "attainment")}
                  </div>
                ) : null}
              </div>
              <div>
                <AccreditationFieldStatus
                  okay={expiry ? moment(expiry).isAfter(moment()) : STATUS_NA}
                  goodMsg="Accreditation has not expired"
                  badMsg="Accreditation has expired"
                  naMsg="Accreditation does not have an expiry"
                />
                {this.renderExpiry(
                  accredType,
                  this.props.accreditation.get("expiry"),
                )}
              </div>
              <div>
                {nswwwcOrgRef ? (
                  <div>
                    <AccreditationFieldStatus
                      okay={true}
                      goodMsg={nswwwcOrgRef}
                      badMsg={null}
                    />
                    {this.renderNswwwcOrgRef(nswwwcOrgRef)}
                  </div>
                ) : null}
              </div>
              {ACCREDITATION_CLAIM_DETAIL_ROWS.map((renderer) =>
                renderer(this.props.accreditation, this.props),
              )}

              <AttachmentModal
                visible={this.state.attchmentModalVisible}
                constituentId={this.props.constituent.get("id")}
                accreditationId={this.props.accreditation.get("id")}
                handleCancel={() => {
                  this.setState({ attchmentModalVisible: false });
                  this.props.getConstituent(this.props.constituent.get("id"));
                }}
              />
            </Col>
            <Col span={8}>
              {attachments && attachments.length > 0
                ? attachments
                    .filter((a) => a.active === true)
                    .map((a, index) => (
                      <Row key={`attachment-${index}`}>
                        <Col span={20}>
                          {shouldRestrictAttachments ? (
                            <Tooltip title="You don't have permission to view NPC attachments. Please contact your administrator.">
                              <span
                                style={{ color: "#888", cursor: "not-allowed" }}
                              >
                                <Icon type="lock" style={{ marginRight: 4 }} />
                                {a.filename && a.filename.length < 20
                                  ? a.filename
                                  : `Attachment${index + 1}`}
                              </span>
                            </Tooltip>
                          ) : (
                            <a
                              href={a.download}
                              title={
                                a.filename && a.filename.length > 20
                                  ? a.filename
                                  : ""
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {a.filename && a.filename.length < 20
                                ? a.filename
                                : `Attachment${index + 1}`}
                            </a>
                          )}
                        </Col>
                        <Col span={4}>
                          {" "}
                          <Icon
                            type="close-circle"
                            style={{
                              cursor:
                                viewOnly || shouldRestrictAttachments
                                  ? "not-allowed"
                                  : "pointer",
                              color: shouldRestrictAttachments
                                ? "#ccc"
                                : undefined,
                            }}
                            onClick={
                              !viewOnly && !shouldRestrictAttachments
                                ? () => this.handleDeleteAttachment(a.id, index)
                                : null
                            }
                          />
                        </Col>
                      </Row>
                    ))
                : null}
            </Col>
          </Row>
          <Row>
            {!NON_REVALIDATION_ACCRED_TYPES.includes(accredType) &&
              !isGeneric && (
                <>
                  <Col span={10}>
                    <div style={{ paddingTop: "1em" }}>
                      <Button
                        icon="reload"
                        size="small"
                        type="primary"
                        loading={this.state.rescanSubmitting}
                        onClick={this.handleRevalidateClick}
                      >
                        Revalidate now
                      </Button>
                    </div>
                  </Col>
                  <Col span={6} />
                </>
              )}
            <Col span={8}>
              {checkFeature("attachments") ? attachmentButton : null}
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

function getAccredName(scanTypes, accred) {
  if (!accred) {
    return null;
  }
  const type = accred.get("type");
  const scanTypesJs = scanTypes && scanTypes.toObject ? scanTypes.toJS() : [];
  const itemFound = scanTypesJs.find((item) => item.typeCode === type);
  const label = (itemFound && itemFound.typeName) || "";
  return label;
}

const getNSWWWCCardType = (accreditation) => {
  // Ensure it's a nswwwc record type
  const type = accreditation.get("type");
  if (type !== "nswwwc") return "";

  const isPendingLoad = accreditation.getIn(
    ["meta", "nswwwc", "pendingLoad"],
    "",
  );
  if (isPendingLoad) return "";

  let cardType;
  cardType = accreditation.getIn(["meta", "nswwwc", "cardType"], null);

  if (cardType) return cardType.substring(0, 1);

  const identifier = accreditation.getIn(["identifier"], "");
  const lastChar = identifier.toUpperCase().slice(-1);
  cardType = lastChar === "E" || lastChar === "V" ? lastChar : "";
  return cardType;
};

@connect((state, ownProps) => ({
  accreditationName: getAccredName(
    state.doc.getIn(["http", "scanTypes", "data"]),
    ownProps.accreditation,
  ),
}))
class AccreditationListClaimTitle extends PureComponent {
  render() {
    const { accreditation, accreditationName, statusColor, queuedScan } = this.props;
    if (!accreditation) {
      return null;
    }
    const vicwwcCardType = accreditation.getIn(
      ["meta", "vicwwc", "cardType"],
      null,
    );
    const taswwcCardType = accreditation.getIn(
      ["meta", "taswwc", "type"],
      null,
    );
    const nswwcCardType = getNSWWWCCardType(accreditation);

    return (
      <span>
        <Badge color={statusColor} />
        {accreditationName}
        {vicwwcCardType && <span> ({vicwwcCardType.substring(0, 1)})</span>}
        {taswwcCardType && <span> ({taswwcCardType.substring(0, 1)})</span>}
        {nswwcCardType && <span> ({nswwcCardType})</span>}
        {queuedScan && (
          <Tooltip
            title={`${String(queuedScan.queueKind || '').toUpperCase()} scan queued at ${queuedScan.queuedAt}`}
          >
            <Tag color="orange" style={{ marginLeft: 8 }}>
              <Icon type="sync" spin style={{ marginRight: 4 }} />
              Scan queued
            </Tag>
          </Tooltip>
        )}
      </span>
    );
  }
}

@connect((state) => ({}), actions)

export class AccreditationsListClaimCard extends PureComponent {
  handleToggleActiveClick = (ev) => {
    ev.preventDefault();
    this.props
      .patchAccreditationClaim(
        this.props.constituent.get("id"),
        this.props.accreditation.get("id"),
        { active: !this.props.active },
      )
      .then((action) => {
        if (action.data._errors) {
          Object.values(action.data._errors).forEach((errors) => {
            errors.forEach((error) => {
              message.error(<span>{error}</span>);
            });
          });
        }
      });
  };

  render() {
    const icon = `${this.props.active ? "close" : "plus"}-circle`;
    const text = this.props.active ? "Deactivate" : "Activate";
    const genacc = this.props.accreditation.getIn(["meta", "genacc"], null);
    const maskDecisionNpc = this.props.maskDecisionNpc || false;
    const { viewOnly = false } = this.props;

    // Override status color to orange/yellow when awaiting decision
    const claimMeta = this.props.claimMeta
      ? Map.isMap(this.props.claimMeta)
        ? this.props.claimMeta.toJS()
        : this.props.claimMeta
      : {};
    const decision = claimMeta.decision;

    // Check if awaiting decision
    let isAwaitingDecision = false;
    if ("actionTaken" in this.props) {
      // From ActionsPage - check actionTaken
      isAwaitingDecision =
        !this.props.actionTaken || this.props.actionTaken === "";
    } else if (decision !== undefined && decision !== null) {
      // From ConstituentPage - only check if decision field exists (indicating it's in the action tracker)
      const decisionLower =
        typeof decision === "string" ? decision.toLowerCase() : "";
      isAwaitingDecision =
        decision === "" ||
        decisionLower === "action pending" ||
        decisionLower === "awaiting decision";
    }

    const displayStatusColor =
      isAwaitingDecision && this.props.statusColor === "red"
        ? "orange"
        : this.props.statusColor;

    return (
      <Spin spinning={this.props.patching}>
        <Card
          headStyle={!genacc ? { backgroundColor: "#DCBFA6" } : null}
          title={
            <AccreditationListClaimTitle
              statusColor={displayStatusColor}
              accreditation={this.props.accreditation}
              viewOnly={this.props.viewOnly}
              queuedScan={this.props.queuedScan}
            />
          }
          type="inner"
          extra={
            <DefinedTerm description={`${text} accreditation`}>
              {!viewOnly && (
                <ActionText onClick={this.handleToggleActiveClick}>
                  <Icon type={icon} />
                </ActionText>
              )}
            </DefinedTerm>
          }
        >
          <AccreditationListClaimBody {...this.props} />
        </Card>
      </Spin>
    );
  }
}

export class AccreditationsListComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      maskDecision: false,
      maskDldriverlicenceId: false,
      fetchTriggerLoading: false,
    };
  }

  handleTriggerFetch = (missingCount) => {
    const { constituent } = this.props;
    if (!constituent) return;
    const email = constituent.get('email') || 'their registered email';
    confirm({
      title: 'Fetch Missing Accreditations',
      content: 'This will send a request to ' + email + ' asking them to provide ' + missingCount + ' missing accreditation' + (missingCount === 1 ? '' : 's') + '. Do you want to proceed?',
      okText: 'Yes, send request',
      cancelText: 'Cancel',
      onOk: async () => {
        this.setState({ fetchTriggerLoading: true });
        try {
          const result = await this.props.triggerRoleBasedFetch(constituent.get('id'));
          this.setState({ fetchTriggerLoading: false });
          if (result && result.data) {
            const status = result.data.status;
            if (status === 'created') {
              message.success(result.data.message || 'Fetch initiated successfully');
            } else if (status === 'no_missing' || status === 'no_requirements') {
              message.info(result.data.message || 'No missing accreditations to fetch');
            } else {
              message.success(result.data.message || 'Request submitted');
            }
          }
        } catch (err) {
          this.setState({ fetchTriggerLoading: false });
          message.error('Failed to trigger fetch. Please try again.');
        }
      },
    });
  }

  componentDidMount() {
    // temporary solution for loader for accreditation claim
    const that = this;
    const { accreditationId, constituentId, type } =
      that.props.accreditationCurrent;
    this.props.fetchOrganizationSettings();
    if (this.props.organizationId) {
      this.props.fetchOrganizationSettingsV2(this.props.organizationId);
    }
    const currentConstituentId = this.props.constituent && this.props.constituent.get('id');
    if (currentConstituentId) {
      this.props.getConstituentQueuedScans(currentConstituentId);
    }
    setTimeout(() => {
      const currentConstituentId = that.props.constituent && that.props.constituent.get('id');
      if (accreditationId && constituentId && constituentId === currentConstituentId) {
        that.props.getConstituent(currentConstituentId);
        that.props.setConstituentAccreditationIdAction();
      } else if (accreditationId && constituentId && constituentId !== currentConstituentId) {
        that.props.setConstituentAccreditationIdAction();
      }
    }, type !== 'genacc' ? window.SERVER_DATA.accreditationTimeOut : 2000);
  }

  componentDidUpdate(prevProps, prevState) {
    const { settings } = this.props;

    const { providers, maskDldriverlicence } =
      (settings && settings.toJSON()) || {};
    const { maskDecision } = (providers && providers.npc) || {};
    this.setState({ maskDecisionNpc: !!maskDecision });

    const maskDldriverlicenceId = maskDldriverlicence || false;
    this.setState({ maskDldriverlicenceId });
  }

  componentWillReceiveProps = (nextProps) => {
    if (!this.props.patchSuccess && nextProps.patchSuccess)
      nextProps.getConstituent(nextProps.constituent.get("id"));

    const prevId = this.props.constituent && this.props.constituent.get("id");
    const nextId = nextProps.constituent && nextProps.constituent.get("id");
    if (nextId && nextId !== prevId) {
      nextProps.getConstituentQueuedScans(nextId);
    }
  };

  renderTypeCell = (text) => (
    <span
      style={{
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
    >
      <em>{text}</em>
    </span>
  );

  renderClaim = (data) => {
    const dataJs = data.toObject ? data.toObject() : data;
    const role = dataJs.role || "accreditation";
    const accreditations =
      this.props.accreditations && this.props.accreditations.toJS();
    const { maskDecisionNpc, maskDldriverlicenceId } = this.state;
    const { isEditable = true } = this.props;

    const accreditationId = dataJs.accreditation && (
      dataJs.accreditation.get ? dataJs.accreditation.get('id') : dataJs.accreditation.id
    );
    const queuedScansJs = this.props.queuedScans && this.props.queuedScans.toJS
      ? this.props.queuedScans.toJS()
      : (this.props.queuedScans || []);
    const queuedScan = accreditationId
      ? queuedScansJs.find((q) => q.accreditationId === accreditationId)
      : null;

    return (
      <List.Item>
        {role === "accreditation" && (
          <AccreditationsListClaimCard
            constituent={this.props.constituent}
            settings={this.props.settings}
            accreditations={accreditations || null}
            userRole={this.props.userRole}
            {...dataJs}
            queuedScan={queuedScan}
            maskDecisionNpc={maskDecisionNpc}
            maskDldriverlicenceId={maskDldriverlicenceId}
          />
        )}
        {role === "queued" && (
          <Card
            headStyle={{ backgroundColor: "#fff7e6" }}
            title={
              <span>
                <Badge status="processing" />
                AHPRA scan queued
                <Tag color="orange" style={{ marginLeft: 8 }}>Pending</Tag>
              </span>
            }
            type="inner"
          >
            <div style={{ fontSize: 13 }}>
              <div><strong>Identifier:</strong> {dataJs.identifier}</div>
              <div><strong>Type:</strong> {String(dataJs.type || '').toUpperCase()}</div>
              <div><strong>Priority:</strong> {dataJs.queueKind}</div>
              <div>
                <strong>Queued:</strong>{' '}
                <Tooltip title={dataJs.queuedAt}>
                  <span>{moment(dataJs.queuedAt).fromNow()}</span>
                </Tooltip>
              </div>
            </div>
          </Card>
        )}
        {role === "new" && isEditable && (
          <div style={{ opacity: 0.5 }}>
            <Link
              to={`/constituents/${this.props.constituent.get("id")}/addAccreditation`}
            >
              <Card
                style={{ cursor: "pointer" }}
                role="button"
                aria-label="Add accreditation"
              >
                <div
                  style={{
                    fontSize: "60px",
                    textAlign: "center",
                  }}
                >
                  <Icon type="plus-circle-o" />
                </div>
              </Card>
            </Link>
          </div>
        )}
        {role === "loading" && <Card loading={true}>Loading</Card>}
      </List.Item>
    );
  };

  render() {
    const {
      constituent,
      patchInProgress,
      patchAccreditationId,
      onCancel,
      accreditationCurrent,
      requiredChecks,
    } = this.props;
    const constituentClaims = constituent
      ? constituent.get("claims", null)
      : null;
    const claims = constituentClaims
      ? constituentClaims
          .toArray()
          .map((claim) =>
            claim.set(
              "patching",
              patchInProgress &&
                claim.getIn(["accreditation", "id"]) === patchAccreditationId,
            ),
          )
      : [];
    const { true: activeClaims, false: inactiveClaims } = _.groupBy(
      claims,
      (claim) => claim.get("active"),
    );

    // Build equivalency data
    const equivRulesRaw = this.props.equivalencyRules;
    const plainEquivRules = equivRulesRaw && equivRulesRaw.toJS ? equivRulesRaw.toJS() : (equivRulesRaw || []);

    // A type counts as "required" if it's directly required OR if it's a "has" type
    // in an equivalency rule that satisfies a required type
    const requiredTypesCodes = (requiredChecks || []).map(check => check.type_code);
    const equivalentHasTypes = {};
    (plainEquivRules || []).forEach(function (rule) {
      var hasType = rule.has || '';
      var satisfies = rule.satisfies || [];
      if (hasType && satisfies.some(function (s) { return requiredTypesCodes.indexOf(s) !== -1; })) {
        equivalentHasTypes[hasType] = true;
      }
    });

    const requiredActiveClaims = [];
    const otherActiveClaims = [];

    (activeClaims || []).forEach(claim => {
      const accredType = claim.getIn(['accreditation', 'type']);
      if (requiredTypesCodes.includes(accredType) || equivalentHasTypes[accredType]) {
        requiredActiveClaims.push(claim);
      } else {
        otherActiveClaims.push(claim);
      }
    });

    // Find missing required accreditations
    const existingTypes = (activeClaims || []).map(claim => claim.getIn(['accreditation', 'type']));
    const missingRequiredChecks = (requiredChecks || []).filter(check => !existingTypes.includes(check.type_code));
    const filteredMissingChecks = filterByEquivalencies(missingRequiredChecks, existingTypes, plainEquivRules);

    const finalInactiveClaims = inactiveClaims || [];

    // Append synthetic items for queued scans that don't yet have an accreditation record.
    const queuedScansJs = this.props.queuedScans && this.props.queuedScans.toJS
      ? this.props.queuedScans.toJS()
      : (this.props.queuedScans || []);
    const pendingQueuedScans = (queuedScansJs || []).filter(
      (q) => q && q.accreditationId == null,
    );
    pendingQueuedScans.forEach((q) => {
      const isRequired =
        requiredTypesCodes.indexOf(q.type) !== -1 || !!equivalentHasTypes[q.type];
      const syntheticItem = { role: "queued", ...q };
      if (isRequired) {
        requiredActiveClaims.push(syntheticItem);
      } else {
        otherActiveClaims.push(syntheticItem);
      }
    });

    const requiredActiveClaimsCount = requiredActiveClaims.length;
    const otherActiveClaimsCount = otherActiveClaims.length;
    const { accreditationId } = accreditationCurrent;
    if (accreditationId) otherActiveClaims.push({ role: "loading" });
    const inactiveClaimsCount = finalInactiveClaims.length;

    // Track loading state separately instead of adding to list
    const showLoadingCard = !constituent;

    const totalActiveCount = requiredActiveClaimsCount + otherActiveClaimsCount;

    return (<Fragment>
      {filteredMissingChecks.length > 0 && (
        <div style={{
          marginBottom: '16px',
          padding: '12px 16px',
          backgroundColor: '#fff7e6',
          border: '1px solid #ffd591',
          borderRadius: '4px'
        }}>
          <div style={{ fontWeight: 600, marginBottom: '8px', color: '#d46b08' }}>
            Missing Required Accreditations
          </div>
          <div style={{ fontSize: '13px', color: '#595959' }}>
            {filteredMissingChecks.map((check, index) => (
              <div key={index} style={{ marginBottom: '4px' }}>
                • {check.type_name}
              </div>
            ))}
          </div>
        </div>
      )}

      <Collapse bordered={false} defaultActiveKey={['active']}>
        <Collapse.Panel
          header={
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingRight: '16px' }}>
              <span>Active Accreditations <Tag>{totalActiveCount}</Tag></span>
              {this.props.isEditable && constituent && (
                <Link
                  to={`/constituents/${constituent.get('id')}/addAccreditation`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Button
                    type="primary"
                    size="small"
                    icon="plus"
                  >
                    Add Accreditation
                  </Button>
                </Link>
              )}
            </div>
          }
          key="active"
        >
          {showLoadingCard ? (
            <Card loading={true}>Loading</Card>
          ) : requiredChecks.length > 0 ? (
            <>
              <div style={{
                fontSize: '13px',
                fontWeight: 600,
                color: '#595959',
                marginBottom: '12px',
                paddingBottom: '8px',
                borderBottom: '1px solid #f0f0f0'
              }}>
                Required <Tag color={filteredMissingChecks.length > 0 ? 'orange' : 'green'} style={{ marginLeft: '8px' }}>{requiredActiveClaimsCount}</Tag>
              </div>
              <List
                dataSource={requiredActiveClaims}
                renderItem={this.renderClaim}
                grid={{
                  gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2,
                  }}
                  locale={{ emptyText: "No required accreditations added yet" }}
                  style={{ marginBottom: "24px" }}
                />
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#595959",
                    marginBottom: "12px",
                    paddingBottom: "8px",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  Other{" "}
                  <Tag style={{ marginLeft: "8px" }}>
                    {otherActiveClaimsCount}
                  </Tag>
                </div>
                <List
                  dataSource={otherActiveClaims}
                  renderItem={this.renderClaim}
                  grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 1,
                    md: 2,
                    lg: 2,
                    xl: 2,
                    xxl: 2,
                  }}
                  locale={{ emptyText: "No other accreditations" }}
                />
              </>
            ) : (
              <List
                dataSource={otherActiveClaims}
                renderItem={this.renderClaim}
                grid={{
                  gutter: 16,
                  xs: 1,
                  sm: 1,
                  md: 2,
                  lg: 2,
                  xl: 2,
                  xxl: 2,
                }}
                locale={{ emptyText: "No active accreditations" }}
              />
            )}
          </Collapse.Panel>
          <Collapse.Panel
            header={
              <span>
                Inactive Accreditations <Tag>{inactiveClaimsCount}</Tag>
              </span>
            }
            key="inactive"
          >
            <List
              dataSource={finalInactiveClaims}
              renderItem={this.renderClaim}
              grid={{
                gutter: 16,
                xs: 1,
                sm: 1,
                md: 2,
                lg: 2,
                xl: 2,
                xxl: 2,
              }}
              locale={{ emptyText: "No inactive accreditations" }}
            />
          </Collapse.Panel>
        </Collapse>
        <PortalChild portal={this.props.footerRef}>
          <Button onClick={onCancel}>Close</Button>
        </PortalChild>
      </Fragment>
    );
  }
}

const AccreditationsList = withRouter(connect(
  state => ({
    patchInProgress: state.doc.getIn(['http', 'patchAccreditationClaim', 'inProgress'], false),
    patchSuccess: state.doc.getIn(['http', 'patchAccreditationClaim', 'success'], false),
    patchConstituentId: state.doc.getIn(['http', 'patchAccreditationClaim', 'meta', 'constituentId']),
    patchAccreditationId: state.doc.getIn(['http', 'patchAccreditationClaim', 'meta', 'accreditationId']),
    accreditationCurrent: state.doc.getIn(['accreditationMr', 'current']),
    accreditations: state.doc.getIn(['http', 'getConstituent', 'data', 'accreditations']),
    getConstituentInProgress: state.doc.getIn(['http', 'getConstituent', 'inProgress']),
    getConstituentFailed: state.doc.getIn(['http', 'getConstituent', 'failed']),
    getConstituent: state.doc.getIn(['http', 'getConstituent', 'data']),
    settings: state.doc.getIn(['http', 'fetchOrganizationSettings', 'data', 'settings'], null),
    userRole: state.doc.getIn(['http', 'UserRole', 'data'], null),
    organizationId: state.doc.getIn(['authMr', 'constituent', 'organization', 'id'], null),
    equivalencyRules: state.doc.getIn(['http', 'fetchOrganizationSettingsV2', 'data', 'accreditationEquivalencies'], null),
    queuedScans: state.doc.getIn(['http', 'getConstituentQueuedScans', 'data', 'queued'], null),
  }),
  actions,
)(AccreditationsListComponent));

export { AccreditationsList, AccreditationFieldStatus };
